var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon87(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8975 10.7417L14.16 17.8467C14.1741 17.9304 14.1624 18.0163 14.1263 18.0932C14.0903 18.17 14.0316 18.2339 13.9583 18.2765C13.8849 18.3191 13.8002 18.3383 13.7156 18.3315C13.6311 18.3246 13.5506 18.2922 13.485 18.2384L10.5016 15.9992C10.3576 15.8916 10.1827 15.8335 10.0029 15.8335C9.82312 15.8335 9.64816 15.8916 9.50414 15.9992L6.51581 18.2375C6.45024 18.2912 6.36986 18.3237 6.28539 18.3305C6.20092 18.3373 6.11637 18.3182 6.04303 18.2758C5.96969 18.2333 5.91104 18.1695 5.87491 18.0928C5.83878 18.0162 5.82688 17.9303 5.84081 17.8467L7.10248 10.7417",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.6667C12.7614 11.6667 15 9.42817 15 6.66675C15 3.90532 12.7614 1.66675 10 1.66675C7.23858 1.66675 5 3.90532 5 6.66675C5 9.42817 7.23858 11.6667 10 11.6667Z",
    stroke: "#057DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon87);
export default __webpack_public_path__ + "static/media/Icon87.a8d49270d6deffd13b768158f98edbb2.svg";
export { ForwardRef as ReactComponent };